<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="bars"></nb-icon>
    </a>
    <a class="logo d-none d-sm-block" href="#" (click)="navigateHome()">
      البريسم
    </a>
  </div>
  <nb-select
    [selected]="currentTheme"
    size="small"
    id="theme-select"
    (selectedChange)="changeTheme($event)"
    status="primary"
  >
    <nb-option *ngFor="let theme of themes" [value]="theme.value">
      {{ theme.name }}</nb-option
    >
  </nb-select>
  <div class="full-screen" (click)="toggleFullScreen()">
    <ng-container *ngIf="!fullScreen; else shrinkTemp">
      <nb-icon icon="expand"></nb-icon>
    </ng-container>
    <ng-template #shrinkTemp>
      <nb-icon icon="compress"></nb-icon>
    </ng-template>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="user-action">
      <span class="user-name">
        <span class="user-name-span">{{ user?.fullname }}</span> -
        {{ arabicPrivileges[user.type] }}
      </span>
    </nb-action>
  </nb-actions>
</div>
